import type * as React from "react";
import { IconType } from "~/common/components/icon/IconType";
import classNames from "classnames";
import { Icon } from "~/common/components/icon/Icon";
import instance from "~/utils/i18n";
import { type ReactNode } from "react";
import ProductPreferredIndicator from "~/features/productDetails/components/ProductPreferredIndicator";

interface ProductTraitProps {
  className?: string;
  icon: ReactNode;
  children?: ReactNode;
}

type ProductTraitType = React.FC<ProductTraitProps>;

const ProductTrait: ProductTraitType = (props) => {
  const { className, icon, children } = props;
  const cls = classNames("scha__product-trait", className);

  return (
    <div className={cls}>
      <div className={"scha__product-trait__icon"}>{icon}</div>
      <span className={"scha__product-trait__label"}>{children}</span>
    </div>
  );
};

interface PredefinedTraitProps {
  className?: string;
}

const BoughtBefore = (props: PredefinedTraitProps) => (
  <ProductTrait {...props} icon={<Icon type={IconType.Star} />}>
    Bought before()
  </ProductTrait>
);

const PreferredProduct = (props: PredefinedTraitProps) => {
  const cls = classNames("scha__product-trait", props.className);
  return (
    <div className={cls}>
      <ProductPreferredIndicator className={"icon-margin"} />
      <span className={"scha__product-trait__label"}>{instance.t("product.isPreferred")}</span>
    </div>
  );
};

const ContractProduct = (props: PredefinedTraitProps) => (
  <ProductTrait {...props} icon={<Icon type={IconType.FilePencil} />}>
    {instance.t("product.isContractItem")}
  </ProductTrait>
);

export const PredefinedTraits = {
  BoughtBefore,
  PreferredProduct,
  ContractProduct,
};
